import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { SelectControl } from '../../../models/controls/select-control';
import { Option } from '../../../models/controls/option';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { OrderService } from '../../../services/order/order.service';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';

@Component({
  selector: 'app-select-control',
  templateUrl: './select-control.component.html',
  styleUrls: ['./select-control.component.scss'],
})
export class SelectControlComponent
  extends BaseControlComponent<SelectControl>
  implements OnInit, AfterViewInit {
  constructor(
    orderService: OrderService,
    dynamicFormService: DynamicFormService
  ) {
    super(orderService, dynamicFormService);
  }

  ngAfterViewInit(): void {
    this.ngModel?.control.setValidators((control) =>
      this.getValidationErrors(control)
    );
    super.ngAfterViewInit();
  }

  protected getValidationErrors(
    control: AbstractControl
  ): ValidationErrors | null {
    return this.ngModel?.value !== this.control.options[0].value
      ? null
      : { required: `${this.control.name}.required` };
  }

  getOptions(): Option[] {
    return (this.control as SelectControl).options;
  }
}
